// extracted by mini-css-extract-plugin
export default {"ingrediensblock":"mca","heading":"nca","item":"oca","fadeIn":"pca","imagewrapper":"qca","modalheader":"rca","amount":"sca","name":"tca","desc":"uca","moredetails":"vca","ingheader":"wca"};
    if(module.hot) {
      // 1743628931564
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  